'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { parseAsString, useQueryState } from 'nuqs';

import { HOUSEHOLD_PAGE_REVAMP_FLAG_CAMEL } from './household-page-flags';

const PREVIEW_PARAM = 'revamp';
const PREVIEW_ON_VALUES = new Set(['1', 'true']);

/**
 * The revamp is on when `flag-household-page-revamp` is on, or when `?revamp=1` is on the URL — a
 * hidden hatch for reviewing the page against a real advisor's data without flipping their flag.
 * The param can only turn the revamp on, never off.
 */
export function useHouseholdPageRevampEnabled(): boolean {
  const flags = useFlags();
  const [previewParam] = useQueryState(PREVIEW_PARAM, parseAsString);

  return (
    flags[HOUSEHOLD_PAGE_REVAMP_FLAG_CAMEL] === true || (previewParam !== null && PREVIEW_ON_VALUES.has(previewParam))
  );
}
